// Textos y reglas de «Cambiar de red» (TA-7 §6, P-28). Aparte del
// componente para que el lint de recarga en caliente no se queje, y para
// que las pruebas los lean sin montar nada.
import { leerErrorDelContrato } from './errorDelContrato';

export const CONSECUENCIA_RED = 'La terminal abrirá la pantalla de red en menos de un minuto y seguirá '
  + 'trabajando con la red actual hasta que la nueva conecte.';
export const SIN_SENALES_RED = 'Ahora está sin señales: abrirá la pantalla de red en cuanto vuelva a conectarse.';

// Qué pasó y qué hacer, con los códigos que contesta la ruta (app.py
// `ajustes_de_red`). ROBADA y SIN_VINCULAR traen su frase del servidor.
export function errorDeCambiarRed(e) {
  const status = e && typeof e === 'object' ? e.status : null;
  if (status === 404) {
    return { codigo: null, mensaje: 'Esa terminal ya no está en tu empresa o en tus sucursales.',
             queHacer: 'Recarga la lista de terminales para ver cómo está ahora.' };
  }
  if (status === 403) {
    return { codigo: 'SIN_PERMISO', mensaje: 'Tu puesto no puede cambiarle la red a una terminal.',
             queHacer: 'Pídeselo a quien administra las terminales de tu empresa.' };
  }
  if (status === 429) {
    return { codigo: 'DEMASIADAS_PETICIONES', mensaje: 'Se pidieron demasiados cambios de red seguidos.',
             queHacer: 'Espera un minuto y vuelve a intentarlo.' };
  }
  return leerErrorDelContrato(e, { terminal: 'esta terminal' });
}

export function motivoDeCambiarRed(t, puede) {
  if (!puede) return 'Solo quien administra las terminales puede cambiarles la red; pídeselo a un encargado.';
  if (t.robada_en) return 'Está marcada como robada: no recibe órdenes. Si apareció, pulsa «Apareció».';
  if (t.estado_v2 === 'SIN_VINCULAR' || !t.vinculada_en) {
    return 'No está vinculada: enciéndela, conéctala con el código de su pantalla y después cámbiale la red.';
  }
  return null;
}
